<section>
<nav class="navbar  navbar-default navbar-fixed-top" id="top">
  <ul class="nav navbar-nav aciglogo">
    <a class="navbar-brand" href="#">
      <img src="assets\theme\en\images\logo.svg" style="width: 200px;position: relative;top: 0px;">
    </a>
  </ul>
  <ul class="nav navbar-nav navbar-right languagechangebtn">
    <li class="langDisable"><button class="MiddleButton" (click)="changeLanguage('ar')" *ngIf="isEnglish">
        <span></span>
        <span></span>
        <span></span>
        <span></span> عربي</button></li>
    <li class="langDisable"><button class="MiddleButton" (click)="changeLanguage('en')" *ngIf="!isEnglish"> <span></span>
        <span></span>
        <span></span>
        <span></span> English</button></li>
  </ul>
</nav>

<div class="LoadContent">
  <router-outlet></router-outlet>
</div>
<div class="wave wave1"></div>
<div class="wave wave2"></div>
<div class="wave wave3"></div>
<div class="wave wave4"></div>
</section>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/BeforeLogin/BeforeLogin.html